import React from "react";
import { Mail, Phone, MapPin, Instagram, Send, Youtube, Linkedin, Facebook, MessageCircle, Music2 } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LangContext";

const SOCIALS = [
  { Icon: Youtube,       href: "https://www.youtube.com/@studygri", label: "YouTube" },
  { Icon: Music2,        href: "https://www.tiktok.com/@studygri", label: "TikTok" },
  { Icon: Linkedin,      href: "https://www.linkedin.com/company/studygri-graduate-react-integrate/", label: "LinkedIn" },
  { Icon: Facebook,      href: "https://www.facebook.com/studygri/", label: "Facebook" },
  { Icon: Instagram,     href: "https://www.instagram.com/studygri/", label: "Instagram" },
  { Icon: MessageCircle, href: "https://api.whatsapp.com/send/?phone=%2B31638633238", label: "WhatsApp" },
  { Icon: Phone,         href: "https://invite.viber.com/?g2=AQAjfV4ISTu%2BFVSitW%2BhH%2FnQnSlTczFXkuy%2BwN%2FD%2BEMsycgyYi5hi6FsCkb0Ir3y&lang=uk", label: "Viber" },
  { Icon: Send,          href: "https://t.me/Vstup_STUDYGRI", label: "Telegram" }
];

const Footer = () => {
  const { t } = useLang();
  return (
    <footer style={{ background: '#1B2A4A', color: '#FFFFFF' }} className="pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="font-display uppercase text-4xl md:text-5xl leading-none" style={{ letterSpacing: '0.02em' }}>
              <span style={{ color: '#FFFFFF', fontWeight: 700 }}>STUDY</span>
              <span style={{ color: '#C9A96E', fontWeight: 700 }}>GRI</span>
            </div>
            <div className="mt-2 text-[10px] uppercase tracking-[0.28em]" style={{ color: '#C9A96E' }}>Premium Education Agency</div>
            <p className="mt-6 text-sm leading-relaxed max-w-md text-white/70">Середня та вища освіта для українців в престижних школах та університетах по всьому світу — STUDYGRI</p>
            <div className="mt-7 flex flex-wrap items-center gap-3" data-testid="footer-socials">
              {SOCIALS.map(({ Icon, href, label }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="w-10 h-10 rounded-full border border-white/15 hover:bg-white/10 hover:border-[#C9A96E] flex items-center justify-center transition">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[10px] uppercase tracking-widest mb-5 font-bold" style={{ color: '#C9A96E' }}>{t("footer.countries")}</div>
            <ul className="space-y-3 text-sm text-white/75">
              <li><Link to="/#countries" className="hover:text-[#C9A96E]">UK</Link></li>
              <li><Link to="/#countries" className="hover:text-[#C9A96E]">USA</Link></li>
              <li><Link to="/#countries" className="hover:text-[#C9A96E]">Netherlands</Link></li>
              <li><Link to="/#countries" className="hover:text-[#C9A96E]">Switzerland</Link></li>
              <li><Link to="/#countries" className="hover:text-[#C9A96E]">Spain</Link></li>
              <li><Link to="/#countries" className="hover:text-[#C9A96E]">Ireland</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] uppercase tracking-widest mb-5 font-bold" style={{ color: '#C9A96E' }}>Розділи</div>
            <ul className="space-y-3 text-sm text-white/75">
              <li><Link to="/universities" className="hover:text-[#C9A96E]">Вузи</Link></li>
              <li><Link to="/schools" className="hover:text-[#C9A96E]">Школи-пансіони</Link></li>
              <li><Link to="/team" className="hover:text-[#C9A96E]">Команда</Link></li>
              <li><Link to="/pricing" className="hover:text-[#C9A96E]">Пакети та ціни</Link></li>
              <li><Link to="/webinar" className="hover:text-[#C9A96E]">Вебінар</Link></li>
              <li><Link to="/blog" className="hover:text-[#C9A96E]">Блог</Link></li>
              <li><Link to="/#reviews" className="hover:text-[#C9A96E]">Відгуки</Link></li>
              <li><Link to="/#faq" className="hover:text-[#C9A96E]">FAQ</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[10px] uppercase tracking-widest mb-5 font-bold" style={{ color: '#C9A96E' }}>{t("footer.contacts")}</div>
            <ul className="space-y-3 text-sm text-white/85">
              <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-0.5" style={{ color: '#C9A96E' }} /> <a href="tel:+380673461626" className="hover:text-[#C9A96E]">+38 067 346 16 26</a></li>
              <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-0.5" style={{ color: '#C9A96E' }} /> <a href="tel:+380504429555" className="hover:text-[#C9A96E]">+38 050 442 95 55</a></li>
              <li className="flex items-start gap-3"><Phone className="w-4 h-4 mt-0.5" style={{ color: '#C9A96E' }} /> <a href="tel:+380673461628" className="hover:text-[#C9A96E]">+38 067 346 16 28</a></li>
              <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5" style={{ color: '#C9A96E' }} /> <a href="mailto:contact@studygri.com" className="hover:text-[#C9A96E]">contact@studygri.com</a></li>
              <li className="flex items-start gap-3"><Send className="w-4 h-4 mt-0.5" style={{ color: '#C9A96E' }} /> <a href="https://t.me/manager_studygri" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A96E]">t.me/manager_studygri</a></li>
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5" style={{ color: '#C9A96E' }} /> <span>Kálmán Imre utca 1, Budapest, 1054 · Toldi utca 4, 3066 Kutasó, Hungary</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 md:items-center md:justify-between text-xs text-white/55">
          <div>© STUDYGRI CONSULT KFT 2026 · ERN 12-09-013224 — Усі права захищені</div>
          <div className="flex gap-5"><a href="#" className="hover:text-white">{t("footer.privacy")}</a><a href="#" className="hover:text-white">{t("footer.offer")}</a></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
